"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpConst = (function () {
    function HttpConst() {
    }
    HttpConst.STATUS_200 = 200;
    HttpConst.STATUS_401 = 401;
    HttpConst.STATUS_403 = 403;
    return HttpConst;
}());
exports.HttpConst = HttpConst;
//# sourceMappingURL=ConstHttp.js.map